import { render, staticRenderFns } from "./xingbieCharts.vue?vue&type=template&id=084d35cc&"
import script from "./xingbieCharts.vue?vue&type=script&lang=js&"
export * from "./xingbieCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports